import React, { useState } from 'react';
import { format } from 'date-fns';
import clsx from 'clsx';
import { CalendarIcon } from '../../../icons/calendarIcon';
import { Calendar } from '../../ui/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/Popover';
import { DeleteIcon } from '../../../icons';

export const DateRangePicker = ({
  title,
  handleDate,
  className = '',
  iconClass = 'stroke-white',
  selected,
  showfromLocal = false,
  showDeleteIcon = true,
  handleApplyClick,
  handleClearClick,
  showApplyButton = false,
  id = 'date',
}) => {
  const [date, setDate] = useState({});
  const [openPopover, setOpenPopover] = useState(false);
  const [triggerWidth, setTriggerWidth] = useState();

  return (
    <Popover
      open={openPopover}
      onOpenChange={(open) => {
        setOpenPopover(open);
      }}
    >
      <PopoverTrigger asChild>
        <div
          id={id}
          variant={'outline'}
          className={clsx(
            `max-lg:justify-center text-left flex rounded-full gap-2 items-center p-2.5`,
            (selected?.form && selected?.to) ||
              (date?.from && date?.to ? 'bg-black text-white' : className)
          )}
          ref={(node) => {
            if (node) setTriggerWidth(node.offsetWidth);
          }}
        >
          <CalendarIcon
            className={clsx(
              'h-4 w-4',
              (selected?.form && selected?.to) ||
                (date?.from && date?.to ? 'stroke-white' : iconClass)
            )}
          />
          {selected?.from ? (
            selected.to ? (
              <>
                {format(selected.from, 'dd/MM/yyyy')} -{' '}
                {format(selected.to, 'dd/MM/yyyy')}
              </>
            ) : (
              format(selected.from, 'dd/MM/yyyy')
            )
          ) : (
            <span> {title ? title : 'Επιλογή ημερ/νίας'}</span>
          )}
          {showDeleteIcon && (selected?.from || selected?.to) && (
            <DeleteIcon
              className="h-4 w-4"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleClearClick();
                if (showfromLocal) {
                  setDate({});
                }
                setOpenPopover(false);
              }}
            />
          )}
        </div>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0 flex flex-col items-center gap-3 pb-6"
        align="center"
        style={{ padding: 0,width: triggerWidth ? triggerWidth : undefined }}
      >
        <Calendar
          initialFocus
          mode="range"
          defaultMonth={date?.from || selected?.from}
          selected={(showfromLocal && date) || (!showfromLocal && selected)}
          onSelect={(value) => {
            if (handleDate) {
              handleDate(value);
            } else {
              setDate(value);
            }
          }}
          numberOfMonths={1}
          className="lg:shadow-none max-lg:w-10/12"
        />
        {showApplyButton && (
          <div>
            <button
              type="button"
              className="btn-primary text-button-primary"
              onClick={() => {
                setOpenPopover(false);
                handleApplyClick(date);
              }}
            >
              Apply
            </button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
